import {
  globalSearchParamsSchema,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_JOB_ID = 'jobId'

export const schedulingSearchParams = z
  .object({
    ...globalSearchParamsSchema.shape,
    [SEARCH_PARAM_SITE_ID]: z.string(),
    [SEARCH_PARAM_JOB_ID]: z.string().optional(),
  })
  .catchall(z.unknown())

export type SchedulingSearchParams = z.infer<typeof schedulingSearchParams>
